const routes = {
  home: "/",
  login: "/login",
  register: "/register",
};

export default routes;
